// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gm4dz3crlIhZKAeKte5M{margin-bottom:20px}.gm4dz3crlIhZKAeKte5M:last-of-type{margin-bottom:0}.gm4dz3crlIhZKAeKte5M .Ayyi19IvumEtU9fjEkXD{padding:8px}.LQySoR5Ke98HnUFKm0iJ{margin:0;padding:0;list-style:none}.LQySoR5Ke98HnUFKm0iJ ul{margin:0;list-style:none}.EISN6tXPFMj0Hf0ITKDr{position:relative}.gm4dz3crlIhZKAeKte5M ul .rDkWtZ6HtJQitij3J1Pj{box-shadow:0 0 0 1.5px var(--interaction-brand-active)inset;border-radius:6px}.CJoq8I4pcouVKfhCAadr{position:relative}.CJoq8I4pcouVKfhCAadr:before{width:100%;height:100%;z-index:var(--zIndex-BASE_10);content:"";background-color:rgba(255,255,255,.8);position:absolute;top:0;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `gm4dz3crlIhZKAeKte5M`,
	"empty": `Ayyi19IvumEtU9fjEkXD`,
	"treeRoot": `LQySoR5Ke98HnUFKm0iJ`,
	"placeholderContainer": `EISN6tXPFMj0Hf0ITKDr`,
	"dropTarget": `rDkWtZ6HtJQitij3J1Pj`,
	"draggingSource": `CJoq8I4pcouVKfhCAadr`
};
export default ___CSS_LOADER_EXPORT___;
